import { Component, HostListener, Input, OnInit } from "@angular/core";
import { Observable, of } from "rxjs";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import { CanvasComponent } from "src/app/annotation/canvas/canvas.component";
import { PhotoViewmodel } from "src/app/core/survey/shared/components/photo-and-remark/photo-viewmodel";
import { DeviceCheckService } from "src/app/core/survey/shared/services/device-check.service";
import { FormValidationService } from "src/app/core/survey/shared/services/formValidation.service";
import { SurveyType } from "src/app/core/survey/shared/services/photo.service";
import { SavingStateService } from "src/app/core/survey/shared/services/saving-state.service";
import { Address } from "src/app/shared/Models/Address";
import { PhotoIndexInfo } from "src/app/shared/Models/interfaces/PhotoIndexInfo.interface";
import { Building, InsideSurvey } from "src/app/shared/Models/read";
import { FacadeDetailPhotoRemarksDto } from "src/app/shared/Models/write/facadeDetailPhotoRemarks.model";
import { ToastService } from "src/app/shared/toast.service";
import { ChangeOutsideSurveyPhotoRemarksDto } from "../../../../../../../shared/Models/write/ChangeOutsideSurveyPhotoRemarksDto";
import {
  InsideSurveyPhoto,
  INSIDE_SURVEY_PHOTO,
} from "../../../../config/inside-survey.magic-strings";
import { FrameListService } from "../../../../services/frameList.service";
const RESULT = "result";

@Component({
  selector: "app-inside-survey-photo-form",
  templateUrl: "./inside-survey-photo-form.component.html",
  styleUrls: ["./inside-survey-photo-form.component.scss"],
  providers: [ToastService],
})
export class InsideSurveyPhotoFormComponent implements OnInit {
  @Input() viewerLayer: HTMLDivElement;
  @Input() isAuthCanWrite: boolean;
  @Input() survey: InsideSurvey;
  @Input() address: Address;
  @Input() index: number;
  @Input() addressIndex: number;
  @Input() buildingIndex: number;
  @Input() buildingKey: number | null;
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;
  @Input() building: Building;
  surveyType = SurveyType;

  viewmodel: PhotoViewmodel = {
    facadePhotos: [],
    detailPhotos: [],
    facadeComment: "",
    detailComment: ([] = []),
  };

  savedPhotoOrder: {
    detailPhotos: PhotoIndexInfo[];
  } = {
    detailPhotos: [],
  };
  unsavedPhotoOrder: {
    detailPhotos: PhotoIndexInfo[];
  } = {
    detailPhotos: [],
  };

  inPortrait: boolean;
  insideSurveyPhotoEnum = InsideSurveyPhoto;

  constructor(
    private _savingStateService: SavingStateService,
    private _deviceCheckService: DeviceCheckService,
    private _frameListService: FrameListService,
    private formValidationService: FormValidationService
  ) {}

  ngOnInit() {
    this.inPortrait = this._deviceCheckService.onPortrait();
    this.viewmodel = {
      facadePhotos: [
        ...this.survey.photos.facadePhotos.filter(
          (f) => f.data.addressId === this.address.id
        ),
      ],
      detailPhotos: [
        ...this.survey.photos.detailPhotos.filter(
          (f) => f.data.addressId === this.address.id
        ),
      ],
      facadeComment: this.survey.photos.facadePhotos.filter(
        (f) => f.data.addressId === this.address.id
      )[0]?.facadeDetailPhotoRemark,
      detailComment: [],
    };
  }
  @HostListener("window:resize")
  onResize() {
    this.inPortrait = this._deviceCheckService.onPortrait();
  }

  getErrors(
    building?: string,
    address?: string,
    subTitle?: string,
    field?: string
  ) {
    return this.formValidationService.getErrors(
      ...[INSIDE_SURVEY_PHOTO, building, address, subTitle, field].filter(
        (x) => !!x
      )
    );
  }

  save(): Observable<any> {
    if (
      !this.viewmodel.facadePhotos.some((e) => e.remarkChanged) &&
      !this.viewmodel.detailPhotos.some((e) => e.remarkChanged)
    )
      return of(true);

    var photoComments = this.viewmodel.facadePhotos
      .filter((e) => e.remarkChanged)
      .map((photo) => {
        photo.remarkChanged = false;
        return new FacadeDetailPhotoRemarksDto(
          photo.data.id,
          photo.facadeDetailPhotoRemark
        );
      });

    photoComments = photoComments.concat(
      this.viewmodel.detailPhotos
        .filter((e) => e.remarkChanged)
        .map((photo) => {
          photo.remarkChanged = false;
          return new FacadeDetailPhotoRemarksDto(
            photo.data.id,
            photo.facadeDetailPhotoRemark
          );
        })
    );

    const dto = new ChangeOutsideSurveyPhotoRemarksDto(
      this.survey.id,
      null,
      photoComments
    );
    return this._savingStateService.addInsideSurveyOutsidePhotoForm(
      dto,
      this.address.id
    );
  }
}
